import React from 'react'
import './Main.css';

export default function Main() {
  return (
    <div className='main-content'>Main</div>
  )
}
